<template>
  <v-btn-toggle
    :value="mode"
    mandatory
    dense
    borderless
    class="list-view-toggle"
    aria-label="List view mode"
    @change="onChange"
  >
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-btn value="cards" small icon class="list-view-toggle__cards" v-bind="attrs" v-on="on">
          <v-icon small>mdi-view-grid-outline</v-icon>
        </v-btn>
      </template>
      <span>Cards</span>
    </v-tooltip>
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-btn value="table" small icon class="list-view-toggle__table" v-bind="attrs" v-on="on">
          <v-icon small>mdi-view-list-outline</v-icon>
        </v-btn>
      </template>
      <span>Table with runs</span>
    </v-tooltip>
  </v-btn-toggle>
</template>

<script>
import { normalizeListViewMode, writeListViewMode } from '@/utils/listViewMode';

/**
 * Cards / table switch of the manual video list (M4 F13). `v-model` is the mode; every change is
 * persisted in localStorage (`listViewMode`) so the choice survives reloads.
 */
export default {
  name: 'ListViewToggle',

  props: {
    value: { type: String, default: 'cards' },
  },

  computed: {
    mode() {
      return normalizeListViewMode(this.value);
    },
  },

  methods: {
    onChange(value) {
      const mode = normalizeListViewMode(value, this.mode);
      if (mode === this.mode) return;
      writeListViewMode(mode);
      this.$emit('input', mode);
    },
  },
};
</script>

<style scoped>
.list-view-toggle {
  background: transparent !important;
}
</style>
